import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'paymentsFilter', namespaced: true })
export default class PaymentsFilter extends FilterModule {
    constructor(module: PaymentsFilter) {
        super(module);
    }
}
